import React from 'react';

import { CreatePersonalClientContext } from './CreatePersonalClientContext';
import { EditPersonalClientContext } from './EditPersonalClientContext';

const useCreatePersonalClientContext = () => React.useContext(CreatePersonalClientContext);
const useEditPersonalClientContext = () => React.useContext(EditPersonalClientContext);

export { useCreatePersonalClientContext, useEditPersonalClientContext };
